import React from 'react'
import Icons from '~/Common-Objects/UI/Icons'
import { cn } from '~/utils/cn'

const LeftToolsNavigation = ({
    currentTool,
    setCurrentTool,
    templateTypeOrig = '',
    templateType = '',
    isForm = false,
    showAiTab = false
}) => {
    let hideChecks = templateType == 'form' || templateType == 'landingPage'
    const showAi = showAiTab && templateType !== 'form'
    return (
        <div className='dndEditorv2-leftTools'>
            <NavigationItem
                icon='plusCircle'
                label='Add'
                isActive={currentTool === 0}
                onClick={() => setCurrentTool(0)}
            />
            <NavigationItem
                icon='brandAnalyser'
                label='Styles'
                isActive={currentTool === 1}
                onClick={() => setCurrentTool(1)}
            />
            {!hideChecks && (
                <NavigationItem
                    icon='tickBreakingCircle'
                    label='Checks'
                    isActive={currentTool === 2}
                    onClick={() => setCurrentTool(2)}
                />
            )}
            {showAi && (
                <NavigationItem
                    icon='sparkle2'
                    label='AI'
                    isActive={currentTool === 3}
                    onClick={() => setCurrentTool(3)}
                />
            )}
        </div>
    )
}

const NavigationItem = ({ icon, label, isActive, onClick }) => {
    return (
        <div
            className={cn('dndEditorv2-leftTools-tool', { 'dndEditorv2-leftTools-tool-active': isActive })}
            onClick={onClick}
        >
            <Icons color='currentColor' icon={icon} />
            {label}
        </div>
    )
}

export default LeftToolsNavigation
